export const TOGGLE_MENU = "toggle_menu";
export const SET_ACTUAL_ELEMENT_ID = "set_actual_element_id";
export const SET_TOP_POSITIONS = "set_top_positions";
